import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PetInsuranceIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M42.5 43.4c-.4 0-.8-.3-1-.7l-.3-1.1c-.1-.3 0-.5.1-.8.1-.2.4-.4.6-.5 2.3-.5 3.9-2.4 3.9-4.6 0-2.6-2.3-4.7-5.1-4.7-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6c4.5 0 8.2 3.5 8.2 7.9 0 3.6-2.6 6.8-6.3 7.7h-.1z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M40.8 28.8c4 0 7.2 3.1 7.2 6.9 0 3.2-2.3 5.9-5.5 6.7l-.3-1.1c2.7-.6 4.7-2.9 4.7-5.6 0-3.2-2.7-5.7-6.1-5.7-.3 0-.6-.3-.6-.6s.2-.6.6-.6m0-2c-1.4 0-2.6 1.2-2.6 2.6 0 1.4 1.1 2.6 2.6 2.6 2.3 0 4.1 1.7 4.1 3.7 0 1.7-1.3 3.2-3.1 3.6-.5.1-1 .5-1.3.9-.3.5-.4 1-.2 1.6l.3 1.1c.2.9 1 1.5 1.9 1.5.2 0 .3 0 .5-.1 4.1-1 7-4.5 7-8.6 0-4.9-4.2-8.9-9.2-8.9z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <path
        d="M7.2 44c-.1 0-.2 0-.3-.1-4-1.3-5.2-4-5.6-6.1-.4-2.1.1-3.8.2-4 .2-.8 1-1.3 1.8-1.3.2 0 .3 0 .5.1.5.1.9.5 1.2.9.2.4.3.9.1 1.4 0 .1-1 3.6 2.6 5.2.4.2.6.6.6 1L8.2 43c0 .3-.2.6-.4.8-.2.1-.4.2-.6.2z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M3.3 33.6h.2c.5.1.7.6.6 1-.1.2-1.2 4.5 3.2 6.5L7.2 43c-3.5-1.2-4.6-3.5-4.9-5.3-.3-1.9.2-3.4.2-3.5 0-.4.4-.6.8-.6m0-2c-1.3 0-2.4.8-2.7 2-.1.2-.6 2.2-.2 4.4.3 1.9 1.6 5.3 6.3 6.8.1.1.3.2.5.2.4 0 .8-.1 1.1-.3.5-.3.8-.9.9-1.5l.1-1.9c.1-.8-.4-1.6-1.2-2-2.7-1.2-2.2-3.6-2.1-4.1.2-.7.1-1.5-.2-2.1-.4-.7-1-1.2-1.8-1.4-.2-.1-.5-.1-.7-.1z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <path
        d="M27.7 43.7c-.3 0-.6-.1-.8-.4-.2-.2-.3-.5-.2-.8.3-1.4 1.1-2.2 1.6-2.6.1-2.1.3-10.4.3-12 0-1-.1-1.2-.1-1.3-.1 0-.1-.1-.2-.1-.2-.2-.9-.6-1.3-.8-.3-.2-.6-.3-.7-.4-.3-.2-.7-.5-.7-3 0-.4.2-.8.6-.9 0 0 .6-.3 1-.4.1 0 .3-.3.5-.4.5-.4 1-.9 1.5-1.1.3-.1.6-.1 1.1-.1h.4c.4-1.1 1.2-1.7 1.3-1.8.2-.1.4-.2.6-.2h.2c.3.1.5.2.7.5.8 1.3 1.6 2.9 1.5 5.8 0 1.9.1 2.7.2 2.9 5.1 6.2 7.4 15.7 7.5 16.1.1.3 0 .6-.2.8-.2.2-.5.4-.8.4h-14z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M32.7 18.2c.6.9 1.4 2.5 1.4 5.3s.3 3.4.3 3.4c5.1 6.2 7.4 15.8 7.4 15.8H27.7c.4-1.7 1.6-2.3 1.6-2.3s.4-10.6.3-12.5c0-1.9-.2-1.8-.6-2.1-.4-.3-1.8-1.1-2-1.3-.2-.2-.3-2.2-.3-2.2s.7-.3 1.1-.5c.4-.2 1.3-1.3 1.9-1.5.2-.1.5-.1.7-.1.6 0 1.2.1 1.2.1.1-1.4 1.1-2.1 1.1-2.1m0-2c-.4 0-.8.1-1.2.4-.1.1-.9.6-1.4 1.6-.4 0-.8.1-1.1.2-.7.2-1.3.8-1.9 1.3-.1.1-.3.2-.4.3-.3.1-.7.3-.8.4-.8.3-1.3 1.1-1.3 1.9 0 2.3.3 3.2 1.1 3.8.2.1.4.2.8.5.3.2.8.5 1.1.7v.7c0 1.5-.2 8.9-.3 11.5-.6.6-1.3 1.5-1.6 2.9-.1.6 0 1.2.4 1.7s1 .7 1.6.7h14.1c.6 0 1.2-.3 1.6-.8.4-.5.5-1.1.4-1.7-.1-.4-2.3-9.8-7.5-16.3-.1-.3-.1-1-.1-2.4 0-3.2-.9-5.1-1.7-6.4-.3-.5-.8-.8-1.3-.9-.2-.1-.4-.1-.5-.1z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <path
        d="M20.3 44c-.2 0-.4-.1-.5-.2-.1 0-.2-.1-.4-.3 0 0 0 .1-.1.1-.2.2-.5.4-.8.4H8.1c-.3 0-.5-.1-.7-.3-.2-.2-.3-.5-.3-.7 0-.5.3-11.9 6.7-26.1 0-1.5.2-8.7 2-11.3.2-.3.5-.4.8-.4.2 0 .4.1.5.2.2.1 1.7 1.2 2.4 2.8 3 .1 3.5.4 3.7.6.4.3.7.7 1 1.2.1.2.3.4.4.5.5 0 2.2.1 3.7.2.5 0 .8.3.9.8.3 1.3.2 4.2-2.7 5.6-.5.2-.9.5-1.3.7-2.2 1.1-2.9 1.5-2.9 2.6 0 2.4.3 16.8.6 18.5.1 0 .2.1.4.2.6.4 1.7 1 1.8 2.5l.1 1.5c0 .3-.1.5-.3.7s-.5.2-.8.2h-3.8z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M16.7 6.1s1.9 1.2 2.2 2.9c0 0 3.4.1 3.9.4.5.3 1.1 1.7 1.5 1.8.4.1 4.1.2 4.1.2s.7 3-2.2 4.5-4.8 2-4.8 4.2.3 18.2.6 18.9c.3.7 2 .9 2.1 2.4l.1 1.5h-3.8s-1.7-1-1.2-6.7c0 0-1.2 3.4-.5 6.7H8.1s.3-11.6 6.7-25.9c0 0 .1-8.4 1.9-10.9m0-2c-.7 0-1.3.3-1.7.9-1.9 2.6-2.2 9.4-2.2 11.6-6.3 14.3-6.7 25.8-6.7 26.3s.2 1.1.6 1.4.9.7 1.4.7h10.5c.3 0 .6-.1.9-.2.3.1.6.2.9.2h3.8c.6 0 1.1-.2 1.5-.6.4-.4.6-.9.5-1.5l-.2-1.6c-.1-1.9-1.5-2.8-2.2-3.2-.2-3-.6-15.8-.5-17.9 0-.5.1-.6 2.3-1.7.4-.2.9-.4 1.4-.7 3.4-1.8 3.6-5.2 3.2-6.8-.2-.9-1-1.5-1.9-1.5-1.1 0-2.4-.1-3.2-.1l-.1-.1c-.4-.5-.7-1.1-1.3-1.4-.3-.2-.8-.5-3.6-.7-.9-1.6-2.3-2.5-2.5-2.7-.2-.3-.6-.4-.9-.4z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <circle cx="29.5" cy="22.3" fill="#E81C30" className={styles.accentColor} r=".7" />
      <circle cx="21.7" cy="11.9" fill="#E81C30" className={styles.accentColor} r=".9" />
      <path
        d="m13.2 17.7 9.1 2.8"
        fill="none"
        stroke="#E81C30"
        className={styles.accentStrokeColor}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </Icon>
  )
}
